import { QueryProvider } from "../queryClient";

const DCS3Provider = QueryProvider;

export const withDCS3Provider = (Component) => (props) => (
	<DCS3Provider>
		<Component {...props} />
	</DCS3Provider>
);
